import { z } from 'zod'

export let groupSchema = z.object({
  name: z.string().min(1, 'Group name is required'),
  userIDs: z.array(z.string()).min(1, 'At least one user must be selected'),
})

export type GroupFormData = z.infer<typeof groupSchema>
